export default {
  personalData: 'Personal data',
};
